"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeNestArray = exports.isEmptyArray = exports.split = exports.groupByField = exports.toArray = exports.distinct = exports.splitTail = exports.headTail = exports.tail = void 0;
const global_1 = require("./global");
function tail(arr) {
    return arr.length ? arr[arr.length - 1] : undefined;
}
exports.tail = tail;
function headTail(arr) {
    return [arr[0], arr[arr.length - 1]];
}
exports.headTail = headTail;
function splitTail(arr) {
    return [arr.slice(0, arr.length - 1), arr[arr.length - 1]];
}
exports.splitTail = splitTail;
function distinct(arr) {
    const target = new Set();
    return arr.filter(v => target.has(v) ? false : !!target.add(v));
}
exports.distinct = distinct;
function toArray(target) {
    return Array.isArray(target) ? target : [target];
}
exports.toArray = toArray;
function groupByField(list, field, nullKey = 'noGroup') {
    let result = { [nullKey]: [] };
    list.forEach((v) => {
        let targetKey = v[field];
        global_1.hasOwnProperty.call(v, field)
            ? global_1.hasOwnProperty.call(result, targetKey)
                ? result[targetKey].push(v)
                : result[targetKey] = [v]
            : result[nullKey].push(v);
    });
    return result;
}
exports.groupByField = groupByField;
function split(arr, size) {
    let target = [];
    if (arr.length > 0) {
        for (let i = 0; i < arr.length; i += size) {
            target.push(arr.slice(i, i + size));
        }
    }
    return target;
}
exports.split = split;
function isEmptyArray(arr) {
    return Array.isArray(arr) ? arr.length === 0 : true;
}
exports.isEmptyArray = isEmptyArray;
function mergeNestArray(list, keys) {
    const [first, ...rest] = list;
    keys.forEach(key => {
        if (Array.isArray(first[key])) {
            rest.forEach(v => Array.isArray(v[key]) && (first[key] = first[key].concat(v[key])));
        }
    });
    return first;
}
exports.mergeNestArray = mergeNestArray;
